export const TIMESLOT_ERROR = "TIMESLOT_ERROR";
export const GET_TIMESLOT = "GET_TIMESLOT";
export const EDIT_TIMESLOT_SUCCESS = "EDIT_TIMESLOT_SUCCESS";
